'use strict';

/*global app*/
/*global services*/
/*global initialize*/
/*global createObjectCallBack*/

function TransferNoteService() {
  this.modal = null;

  this.init();
}

TransferNoteService.prototype = $.extend({}, {
  constructor: 'TransferNoteService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.transfer-note__create', function () {
      _this.create($(this).data('article_id'), $(this).data('tag'), $(this).data('jobcard_rid'), $(this).data('jcoperation_rid'));

      return false;
    });

    $('body').on('click', '.transfer-note__create-mismatch', function () {
      _this.createMismatch($(this).data('article_id'));

      return false;
    });

    $('body').on('change', '.transfer-note-bulk-modal input[name="items"]', function () {
      _this.switchItemsVisibility($(this).val());
      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  doCreateMismatch: function doCreateMismatch(articleId, reason, quantity) {
    var _this = this;

    var data = {
      WorkplaceRID: app.param('workplace_rid'),
      ArticleId: articleId,
      ReasonId: reason.Id,
      Quantity: quantity
    };

    services.get('user-additional-login').isUserLogined(function () {
      app.getFormation('production_transfer_note:create_mismatch', data, function (res) {
        if (res.msg === 'SUCCESS') {
          app.viewSuccessMessage();

          $('body').trigger('transfer-note-mismatch-created');
        } else if (res.msg === 'NOT_VALID') {
          app.viewWarningMessage();
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    });

    return _this;
  },

  createMismatch: function createMismatch(articleId) {
    var _this = this;

    services.get('article').get(articleId, function (data) {
      services.get('reason').chooseReason(app.param('workplace_rid'), function (reason) {
        if (!reason) {
          return;
        }

        var options = {
          content: app.t('transfer_note.mismatch_help').replace('{ArticleName}', data.Name).replace('{ReasonDescription}', reason.Description),
          asHtml: true,
          suffix: data.AltUnit
        };

        app.getValue(options, function (value) {
          if (value > 0) {
            _this.doCreateMismatch(articleId, reason, value);
          }
        });
      });
    });

    return _this;
  },

  doCreate: function doCreate(articleId, quantity, tag, jobCardRID, jcOperationRID) {
    var _this = this;

    var data = {
      WorkplaceRID: app.param('workplace_rid'),
      ArticleId: articleId,
      Quantity: quantity,
      JobCardRID: jobCardRID,
      JCOperationRID: jcOperationRID
    };

    services.get('user-additional-login').isUserLogined(function () {
      app.getFormation('production_transfer_note:create', data, function (res) {
        if (res.msg === 'SUCCESS') {
          app.viewSuccessMessage();

          res.data.tag = tag;
          $('body').trigger('transfer-note-created', res.data);
        } else if (res.msg === 'NOT_VALID') {
          app.viewWarningMessage();
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    });

    return _this;
  },

  create: function create(articleId, tag, jobCardRID, jcOperationRID) {
    var _this = this;

    jobCardRID = jobCardRID || 0;
    jcOperationRID = jcOperationRID || 0;

    services.get('article').get(articleId, function (data) {
      var options = {
        content: app.t('transfer_note.help').replace('{ArticleName}', data.Name).replace('{ArticleAbbr}', data.Abbr).replace('{ArticleAbbr2}', data.Abbr2),
        asHtml: true,
        suffix: data.AltUnit
      };

      app.getValue(options, function (value) {
        if (value > 0) {
          _this.doCreate(articleId, value, tag, jobCardRID, jcOperationRID);
        }
      });
    });

    return _this;
  },

  initializeBulkForm: function initializeBulkForm(res) {
    var _this = this;

    _this.modal.content(res.data.html);

    initialize(_this.modal.contentDOM());

    return _this;
  },

  doCreateBulk: function doCreateBulk() {
    var _this = this;

    var $form = _this.modal.contentDOM().find('form');

    services.get('user-additional-login').isUserLogined(function () {
      _this.modal.block();
      app.post('transfer_note_bulk', { WorkplaceRID: app.param('workplace_rid') }, $form.serialize(), function (res) {
        _this.modal.unBlock();

        if (res.msg === 'SUCCESS') {
          app.viewSuccessMessage();

          _this.modal.close(function () {
            $('body').trigger('transfer-note-bulk-created', res.data);
          });
        } else if (res.msg === 'NOT_VALID') {
          _this.initializeBulkForm(res);
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    });

    return _this;
  },

  createBulk: function createBulk(items, jobCardRID, jcOperationRID, operationId) {
    var _this = this;

    var data = {
      WorkplaceRID: app.param('workplace_rid'),
      Items: items,
      JobCardRID: jobCardRID,
      JCOperationRID: jcOperationRID,
      OperationId: operationId
    };

    _this.modal.open({
      height: 'auto',
      width: 'lg',
      form: true,
      focusInput: false,
      submitCallBack: createObjectCallBack(_this, 'doCreateBulk'),
      enterSubmitCallBack: createObjectCallBack(_this, 'doCreateBulk'),
      modalClass: 'transfer-note-bulk-modal'
    });

    _this.modal.block();
    app.post('transfer_note_bulk', { WorkplaceRID: app.param('workplace_rid') }, data, function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.initializeBulkForm(res);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  switchItemsVisibility: function switchItemsVisibility($value) {
    var _this = this;

    var $itemsAll = _this.modal.contentDOM().find('.transfer-note-bulk__item');
    var $itemsNotAvailable = _this.modal.contentDOM().find('.transfer-note-bulk__item--not-available');
    if ($value === 'not_available') {
      $itemsAll.hide();
      $itemsNotAvailable.show();
    } else {
      $itemsAll.show();
    }

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-transfer-note');

    _this.registerCallbacks();

    return _this;
  }
});
